import { useState } from 'react';
import { useSnackbar } from './useSnackbar';


export const useRetainAnswerToggle = ( onSave: any )=> {
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();

  const toggleRetainAnswer = async (question: any) => {
    setIsLoading(true);
    try {
      const newRetainAnswer = !question.retainAnswer;
      const updatedQuestion = {...question, retainAnswer: newRetainAnswer };
      const { success, error } = await onSave(updatedQuestion);

      if (success) {
        showSuccessSnackbar('Retain answer setting updated successfully');
      } else {
        throw new Error(error || 'Failed to update retain answer setting');
      }
    } catch (error) {
      showErrorSnackbar(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, toggleRetainAnswer };
};